// extracted by mini-css-extract-plugin
export var registr = "styles-module--registr--rVF-p";
export var registr_txt = "styles-module--registr_txt--36c9H";
export var registr_txt_title = "styles-module--registr_txt_title--389Je";
export var registr_form = "styles-module--registr_form--1iHua";